import { useTranslations } from 'next-intl'
import { PERSONAL_AREA_NAME } from '@/config/constants'

const varMaps = {
  PERSONAL_AREA_NAME,
  BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
}

const loggedMenu = [
  {
    label: 'Header.LoggedMenu.personalArea.label',
    href: 'Header.LoggedMenu.personalArea.href',
  },
  {
    label: 'Header.LoggedMenu.logout.label',
    href: 'Header.LoggedMenu.logout.href',
    'data-color': 'danger',
  },
]

const MenuLoggedModel = () => {
  const t = useTranslations()

  const menuTranslated = loggedMenu.map(({ label, href, ...rest }) => {
    return {
      ...rest,
      label: t(label),
      href: t(href),
    }
  })

  Object.keys(varMaps).forEach((key) => {
    menuTranslated.forEach((item) => {
      item.href = item.href.replace(
        `[${key}]`,
        varMaps[key as keyof typeof varMaps] || ''
      )
    })
  })

  return menuTranslated
}

export default MenuLoggedModel
